import React from 'react';
import styled from 'styled-components';
import { LockIcon } from 'assets/lock-icon';
import { BankIcon } from 'assets/bank-icon';
import useTranslation from 'hooks/use-translation';
import { EllipsisLoader } from './ellipsis-loader';
import { TextCarousel } from './text-carousel';

type DutchiePayLoadingModalProps = {
  steps: string[];
};

export function DutchiePayLoadingView({ steps }: DutchiePayLoadingModalProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <LoadingContainer>
      <AnimationSection>
        <LockIcon bodyColor='var(--icon-panel-color)' inkColor='var(--icon-ink-color)' />
        <LoaderContainer>
          <EllipsisLoader />
        </LoaderContainer>
        <BankIcon
          panelColor='var(--icon-panel-color)'
          roofColor='var(--icon-roof-color)'
          inkColor='var(--icon-ink-color)'
        />
      </AnimationSection>
      <TextCarouselContainer>
        <TextCarousel steps={steps} />
      </TextCarouselContainer>
      <TextSection> {t('dutchiePay.takeAwhile', 'This may take awhile, please be patient.')}</TextSection>
    </LoadingContainer>
  );
}
const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AnimationSection = styled.div`
  display: flex;
  align-items: center;

  /* Panel/ink colors for LockIcon/BankIcon, passed down as color props (see
     bank-icon.tsx for why they're applied via style rather than attribute). */
  --icon-panel-color: #eaeff2;
  --icon-roof-color: #bccad2;
  --icon-ink-color: #5e6d79;
  .concierge-mode & {
    --icon-panel-color: var(--dcm-color-surface-hover);
    --icon-roof-color: var(--dcm-color-surface-muted);
    --icon-ink-color: var(--dcm-color-text-secondary);
  }
`;

const LoaderContainer = styled.div`
  margin: 0 10px;
`;

const TextCarouselContainer = styled.div`
  margin: 10px 0 15px 0;
`;

const TextSection = styled.p`
  font-size: 14px;
  --dp-loading-text-color: ${({ theme }) => theme.colors.grey[40]};
  .concierge-mode & {
    --dp-loading-text-color: var(--dcm-color-text-muted);
  }
  color: var(--dp-loading-text-color);
`;
